<template>
  <div v-if="left">
    <v-flex v-if="Object.keys(right).length !== 0" class="d-flex">
      <span class="subtitle-1 py-1 px-4">{{totalChanges}}</span>
      <v-btn icon color="success text--darken-2" @click="showDiffsClick" :disabled="totalChanges === 0">
        <v-icon>
          mdi-card-search-outline
        </v-icon>
      </v-btn>
    </v-flex>
    <span v-else disabled>Not enough history</span>
    <profile-changes ref="profileChangesDialog" :totalChanges="totalChanges" :delta="delta" :left="left" :right="right"></profile-changes>
  </div>
</template>

<script>
  import ProfileChanges from "../../Dialogs/Profiles/profileChanges";

  export default {
    name: "showDiffs",
    components: {ProfileChanges},
    props: ['left', 'right', 'totalChanges', 'delta'],
    data() {
      return {
        open: false,
      }
    },
    methods: {
      showDiffsClick() {
        // this.$ga.event('Staff', 'open modal', 'profile changes modal');
        this.$gtag.event('open modal', {
          event_category: 'Staff',
          event_label: 'profile changes modal'
        });
        this.$refs.profileChangesDialog.openModal();
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Buttons/Profiles/showDiffs.vue